/*
 * @Author: Wang Wenmao
 * @Date: 2023-12-07 10:07:37
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2023-12-07 10:38:18
 * @Description: 积分展示
 */
import React, { Component } from 'react';
import { Form, Slider, Button } from 'antd';
import DetailTitle from '../../DetailTitle';
import { FormItemLayout, ConfigFormDecorator } from '../../tools';

const FormItem = Form.Item;

const styleList = [
    {
        id: 1,
        name: '样式一',
        left: '0px',
        disable: false,
    },
    {
        id: 2,
        name: '样式二',
        left: '20px',
        disable: true,
    },
];

/**
 * 商品列表组件-配置信息
 *  */
class Index extends Component<any> {
    handleChangeItem = (item: any) => {
        const { onChange, value } = this.props;
        let newData = JSON.parse(JSON.stringify(value));
        newData = { ...newData, ...item };
        onChange(newData);
    };

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Form>
                <DetailTitle label="背景设置" />
                <FormItem {...FormItemLayout} label="页面边距">
                    {getFieldDecorator('pageMargin')(<Slider max={100} min={0} />)}
                </FormItem>
                <FormItem {...FormItemLayout} label="背景圆角">
                    {getFieldDecorator('bgRoundedCorners')(<Slider max={100} min={0} />)}
                </FormItem>
                <DetailTitle label="模板样式" />
                <FormItem {...FormItemLayout} label="选择模板">
                    {getFieldDecorator('showStyle')(
                        <>
                            {styleList.map((item: any) => (
                                <Button
                                    key={item.id}
                                    type={item.id === 1 ? 'primary' : 'default'}
                                    shape="round"
                                    style={{ marginLeft: item.left }}
                                    disabled={item.disable}
                                >
                                    {item.name}
                                </Button>
                            ))}
                        </>
                    )}
                </FormItem>
            </Form>
        );
    }
}

export const PointsDisplay = ConfigFormDecorator(Index);
